module.exports = __webpack_public_path__ + "img/green-circle-table-6.3db98658.png";